rs.module("development/codedemosgrideditinghideshow",

    ["common/visibility"],

    function (visibility) {

        function initialize(jsSelectors) {

            var hideShowSelect = $.js(jsSelectors.hideShowSelect);
            var gridContainer = $.js(jsSelectors.gridContainer);

            // Hide/Show Select
            hideShowSelect.on("change", function () {

                var value = hideShowSelect.val();

                // set editable grid visibility
                visibility.setVisible(gridContainer, value == "Show");
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);